"use client";

import Link from "next/link";
import { useLocale } from "next-intl";

import type { AppLocale } from "@/i18n/routing";
import { getTagHref } from "@/integrations/articles/routes";
import { cn } from "@/lib/utils/cn";

interface TagListProps {
  tags: string[];
  className?: string;
  chipClassName?: string;
}

export function TagList({ tags, className, chipClassName }: TagListProps) {
  const locale = useLocale() as AppLocale;

  if (tags.length === 0) {
    return null;
  }

  return (
    <ul className={cn("flex flex-wrap gap-2", className)}>
      {tags.map((tag) => (
        <li key={tag}>
          <Link
            href={getTagHref(tag, locale)}
            className={cn(
              "inline-flex items-center rounded-full border border-paper-3 bg-paper px-3 py-1 text-xs font-medium text-ink-2 transition-colors hover:border-ink-3 hover:text-ink",
              chipClassName,
            )}
          >
            {tag}
          </Link>
        </li>
      ))}
    </ul>
  );
}
